import store from '../store';

export default async function entryFinancialReport({ next, router }) {

    store.commit('SET_PRODUCT_TYPE', 'EntryFinancialReport');
  
   
      if (store.getters.isAuthenticated)
        return router.push({ name: "CreateReportFormat", params:{report:'financial' } });
    else       
        return router.push({ name: "Login" });

    
    return next();
}
